import { DEFAULT_FIELD_VALUES, ModelFactory } from "jimbo/model/base"; 


export const ticketsClassFactory = new ModelFactory();

ticketsClassFactory.addClassDescriptionsData([
    {
        clazzName: "TicketCode",
        verboseName: "None",

        fields: [
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "id",
                "auto_created": true,
                "type": "persistent.fields.CharField",
                "init_value": "null",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "ticketCode",
                "type": "persistent.fields.CharField",
                "init_value": "",
            }, 
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "created",
                "type": "persistent.fields.DateTimeField",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "usedAt",
                "type": "persistent.fields.DateTimeField",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "validUntil",
                "type": "persistent.fields.DateTimeField",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "isSold",
                "type": "persistent.fields.BooleanField",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "ticketBatch",
                "type": "persistent.fields.OneOf",
                "relation_clazz": "TicketBatch",
                "init_value": "null",
                "null": true,
            },
        ]
    },
    {
        clazzName: "TicketBatch",
        verboseName: "Ticket Batch",
        fields: [
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "id",
                "auto_created": false,
                "type": "persistent.fields.CharField",
                "init_value": "null",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "name",
                "max_length": 512,
                "type": "persistent.fields.CharField",
            }
        ],

    },
    {
        clazzName: "TicketCsvDownload",
        verboseName: "Ticket Csv Download",
        fields: [
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "nrOfTickets",
                "max_length": 200,
                "type": "persistent.fields.IntegerField",
            }
        ],

    }
]);
